<div class="sideCard {{IsShow ? 'active' : ''}}" *ngIf="EventData">
    <div class="col-4 side">
        <label>您正在報名⋯</label>
        <ng-container *ngIf="IsMobile">
            <div class="close" (click)="ToggleCard()">
                <i class="icon icon-close">&#xe802;</i>
            </div>
        </ng-container>
        <h1>{{BuyerData.company_name}}</h1>
        <div class="item">
            <label>國別</label>
            <p>{{BuyerData.country.name}}({{BuyerData.country.continental}})</p>
        </div>
        <div class="item" *ngIf="BuyerData.company_url">
            <label>公司網址</label>
             <p><a href="{{BuyerData.company_url}}" target="_blank">{{BuyerData.company_url}}</a></p>
        </div>
        <div class="item">
            <label>營業項目</label>
            <p>{{BuyerData.business_items}}</p>
        </div>
        <div class="item">
            <label>採購產品</label>
            <div class="tags">
                <ng-container *ngFor="let prod of BuyerData.products">
                    <span>{{prod.name}}</span>
                </ng-container>
            </div>
        </div>
        <div class="item" *ngIf="BuyerData.displayMemo">
            <label>備註</label>
            <p>{{BuyerData.memo}}</p>
        </div>
        <hr/>
        <div class="relative">
            <div class="title">
                <label>所屬採購案</label>
                <span *ngIf="EventData.leftAppointmentCount > 0">此活動尚可預約 {{EventData.leftAppointmentCount}} 次</span>
            </div>
            <h2>{{EventData.name}}</h2>
            <p class="time">
                <i class="icon icon-clock">&#xe80d;</i>{{EventData.eventFullDateTime}}
            </p>
            <p class="addr">
                <i class="icon icon-web">&#xe805;</i>{{EventData.location}} 
                <a *ngIf="EventMap != ''" href="{{EventMap}}" target="_blank">
                    <span class="map"><i class="icon icon-map">&#xe804;</i>地圖</span>
                </a>
            </p>

        </div>
    </div>
</div>